import axios from "../helpers/axios";
import { MobilePaymentDto } from "../models/dtos/mobilePayment.dto";
import { MobilePaymentStatusDto } from "../models/dtos/mobilePaymentStatus.dto";
import { PaymentCardDto } from "../models/dtos/paymentCard.dto";
import { VposPaymentDto } from "../models/dtos/vposPayment.dto";

// Define the StartPaymentRequest interface
interface StartPayTrPaymentRequest {
  ccOwner?: string;
  cardNumber?: string;
  expiryMonth?: string;
  expiryYear?: string;
  cvv?: string;
  subscriptionType: string;
  cardId?: number;
}

export default class PaymentService {
  // payment/mobile/start excluded from apiErrorModal
  async startPayment(): Promise<MobilePaymentDto> {
    try {
      const response = await axios.post<MobilePaymentDto>(
        `${process.env.REACT_APP_BASE_URL}/payment/mobile/start`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // payment/mobile/status excluded from apiErrorModal
  async mobilePaymentStatus(smsCid: string): Promise<MobilePaymentStatusDto> {
    try {
      const response = await axios.get<MobilePaymentStatusDto>(
        `${process.env.REACT_APP_BASE_URL}/payment/mobile/status?smsCid=${smsCid}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async startVposPayment(isYearly: boolean): Promise<VposPaymentDto> {
    try {
      const response = await axios.post<VposPaymentDto>(
        `${process.env.REACT_APP_BASE_URL}/payment/vpos/start?yearly=${isYearly}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async cancelSubscription(): Promise<void> {
    try {
      const response = await axios.post<void>(
        `${process.env.REACT_APP_BASE_URL}/payment/cancel-subscription`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async startFreeTrial(): Promise<void> {
    try {
      const response = await axios.post<void>(
        `${process.env.REACT_APP_BASE_URL}/payment/start-free-trial`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getPaymentCards(): Promise<PaymentCardDto[]> {
    try {
      const response = await axios.get<PaymentCardDto[]>(
        `${process.env.REACT_APP_BASE_URL}/payment/pay-tr/cards`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async deletePaymentCard(cardId: string): Promise<void> {
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/payment/pay-tr/delete-card?cardId=${cardId}`
      );
    } catch (error) {
      throw error;
    }
  }

  async startPayTrPayment(request: StartPayTrPaymentRequest): Promise<string> {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/payment/pay-tr/start`,
        request,
        {
          responseType: "text",
          headers: {
            Accept: "text/html",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async cancelPayTrSubscription(): Promise<void> {
    try {
      const response = await axios.post<void>(
        `${process.env.REACT_APP_BASE_URL}/payment/pay-tr/cancel`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
